import { Navigate, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import ArrowBack from '@mui/icons-material/ArrowBack'

import { useAppSelector } from 'src/store/hooks'
import { selectUseQuizAnalyticsV2 } from 'src/v3/settings/settings.slice'
import { useScrollToTop } from 'src/v3/utilities/hooks/use-scroll-to-top'
import { MIN_BUTTON_SIZE } from '../constants'
import QuizAnalyticsEmptyState from './components/quiz-analytics-empty-state'

// :quizID isn't read or validated yet; quiz data arrives in a later ticket.
let QuizAnalyticsDetailContent = () => {
  let navigate = useNavigate()

  useScrollToTop()

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box className="flex flex-col gap-6">
        <Box className="flex items-center gap-2">
          <IconButton
            onClick={() => navigate('/manage/quiz-analytics')}
            aria-label="Go back to Quiz Analytics"
            sx={{ minWidth: MIN_BUTTON_SIZE, minHeight: MIN_BUTTON_SIZE }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h5" component="h1">
            Quiz Detail
          </Typography>
        </Box>
        <QuizAnalyticsEmptyState
          title="Quiz details are coming soon"
          description="Question-level results for this quiz will appear here."
        />
      </Box>
    </Container>
  )
}

let QuizAnalyticsDetailPage = () => {
  let useQuizAnalyticsV2 = useAppSelector(selectUseQuizAnalyticsV2)

  if (!useQuizAnalyticsV2) {
    return <Navigate to="/manage" replace />
  }

  return <QuizAnalyticsDetailContent />
}

export default QuizAnalyticsDetailPage
